import {apiPost} from '@api/api'
import {ApiRes} from '@type/api'
import {IConfirmResponse} from '@api/auths/register/Register'

export const apiEditThumbnail = async (thumbnail?: string): Promise<ApiRes<IConfirmResponse>> => {
    return await apiPost('edit', {
        thumbnail: thumbnail || '',
    })
}
